import slugify from 'react-slugify'
import { TocItem } from '../ui/GuideTableOfContents'
import { ArticleResponse } from '@app/services/strapiServices'

type ContentBlockType = NonNullable<NonNullable<ArticleResponse['data']>[0]['content_blocks']>[0]

const stripFencedCode = (md: string) => md.replace(/```[\s\S]*?```/g, '')

const makeSlugger = () => {
  const counts = new Map<string, number>()
  return (raw: string) => {
    const base = slugify(raw)
    const n = (counts.get(base) ?? 0) + 1
    counts.set(base, n)
    return n === 1 ? base : `${base}-${n}`
  }
}

const stripEmphasis = (s: string) =>
  s
    .replace(/\*\*\*(.+?)\*\*\*/g, '$1')
    .replace(/\*\*(.+?)\*\*/g, '$1')
    .replace(/\*(.+?)\*/g, '$1')
    .replace(/___(.+?)___/g, '$1')
    .replace(/__(.+?)__/g, '$1')
    .replace(/_(.+?)_/g, '$1')
    .replace(/`(.+?)`/g, '$1')
    .trim()

export const createTableOfContents = (
  contentBlocks: ContentBlockType[] | undefined,
): TocItem[] | undefined => {
  if (!contentBlocks) return undefined

  return contentBlocks
    .filter((block): block is ContentBlockType & { Title: string; body?: string } =>
      Boolean(block?.Title?.trim()),
    )
    .map((block) => {
      const parentId = slugify(block.Title)
      const body = typeof block.body === 'string' ? block.body : ''
      const cleaned = stripFencedCode(body)

      const nestedHeading = /^#{3,4}(?!#)\s+(.+?)\s*#*\s*$/gm

      const childSlug = makeSlugger()
      const children: TocItem[] = []

      let markdown: RegExpExecArray | null
      while ((markdown = nestedHeading.exec(cleaned))) {
        const rawTitle = markdown[1].trim()
        if (!rawTitle) continue

        const title = stripEmphasis(rawTitle)
        if (!title) continue

        children.push({
          id: childSlug(title),
          title,
          children: [],
        })
      }

      return {
        id: parentId,
        title: block.Title,
        children,
      }
    })
}
